import React, { useState, useEffect } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import axios from "axios";
import {
  APP_DEV_URL,
  APP_BASE_URL,
  VAVE,
  GETIDEACATEGORY,
  GETDOMAIN,
  GETLOCATION,
  GETIDEAEFFECTIVEAGGREGATE,
  GETMODEL,
  SAVEIDEAGENERATION,
  GETSAVEIDEAFORCOUNT,
  DOWNLOADIDEABYID
} from "../../../Pages/AppConstant";
import { toWords } from "number-to-words";
import "./index.css";
import {
  adminEmpIds,
} from "../switch_on_userlist";
function AddRequestForm({ Setisloading }) {
  // const[isloading,Setisloading] = useState(false)

  const [variantList, setVariantList] = useState([]);
  const [subVariantList, setSubVariantList] = useState([]);

  const [selectedSubVariant, setSelectedSubVariant] = useState("");

  const [selectedIdeaCategory, setselectedIdeaCategory] = useState("");
  const [selectedOtherIdeaCategory, setselectedOtherIdeaCategory] =
    useState("");
  const [ideaCategoriesList, setIdeaCategoriesList] = useState([]);
  const [domainList, setDomainList] = useState([]);

  const [locationList, setLocationList] = useState([]);
  const [ideaEffectiveAggregateList, setIdeaEffectiveAggregateList] = useState(
    []
  );

  const [selectedIdeaEffectiveAggregate, setselectedIdeaEffectiveAggregate] =
    useState("");
  const [selectedPDOwnerName, setselectedPDOwnerName] = useState("");
  const [selectedPDOwnerId, setselectedPDOwnerId] = useState("");
  const [selectedSourcingOwnerName, setselectedSourcingOwnerName] = useState("");
  const [selectedSourcingOwnerId, setselectedSourcingOwnerId] = useState("");
  const [selectedModel, setselectedModel] = useState("");
  const [modelList, setModelList] = useState([]);
  const [modelTempList, setModelTempList] = useState([]);
  const [ideaListCount, setIdeaListCount] = useState("");

  const [selectedVariant, setSelectedVariant] = useState("");
  const [selectedDomain, setselectedDomain] = useState("");
  const [selectedOtherDomain, setselectedOtherDomain] = useState("");
  const [selectedLocation, setselectedLocation] = useState("");

  const [partDesc, setPartDesc] = useState("");

  const [partNo, setPartNo] = useState("");

  const [currentCondition, setCurrentCondition] = useState("");

  const [proposedIdea, setProposedIdea] = useState("");

  const [tentative, setTentative] = useState("");

  const [functionName, setFunctionName] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);

  const numberToWords = (num) => {
    if (!num) return "";
    return toWords(Number(num)) + " rupees";
  };
  const filechangedeed = (event) => {
    const file = event.target.files[0];
    const id = event.target.id;

    if (!file) return;

    if (file.type === "application/pdf") {
      if (file.size <= 5 * 1024 * 1024) {
        // Valid file
        setSelectedFile(file);
      } else {
        // File too large
        document.getElementById(id).value = "";
        alert("Upload size should not exceed 5 MB");
      }
    } else {
      // Invalid type
      document.getElementById(id).value = "";
      alert("Please upload only PDF files.");
    }
  };
  const handleSubmit = async (event) => {
    Setisloading(true);
    event.preventDefault();

    // Minimal field validation
    if (
      !(selectedIdeaCategory === "Other"
        ? selectedOtherIdeaCategory
        : selectedIdeaCategory) ||
      !partNo ||
      !partDesc ||
      !proposedIdea ||
      !currentCondition ||
      !tentative ||
      !selectedModel ||
      !selectedVariant ||
      !selectedSubVariant ||
      !(selectedDomain === "Other" ? selectedOtherDomain : selectedDomain) ||
      !functionName ||
      !selectedLocation ||
      !selectedIdeaEffectiveAggregate
      // ||
      // !selectedFile
    ) {
      alert("Please fill all required fields.");
      Setisloading(false);
      return;
    }

    let newCount = 1; // Default idea ID in case API returns empty list

    try {
      // Fetch existing ideas to find max ID
      const res = await axios({
        method: "get",
        url: VAVE + GETSAVEIDEAFORCOUNT,
        withCredentials: false,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const data = res.data.data;

      const maxId = data.reduce((max, item) => {
        return item.id > max ? item.id : max;
      }, 0);

      newCount = maxId + 1;

      setIdeaListCount(newCount);
    } catch (error) {
      console.error("Error fetching existing idea IDs:", error);
      alert("Failed to get idea ID. Please try again.");
      return;
    }

    const formData = new FormData();

    if (selectedFile) {
      formData.append("filepath", selectedFile);
      formData.append("type", "Partnership_deed");
    }

    formData.append("emp_id", localStorage.getItem("empid"));
    formData.append("emp_email", localStorage.getItem("emailid"));
    formData.append("partNo", partNo);
    formData.append("idea_id", newCount);
    formData.append("idea_unique_id", `SWON-${newCount}`);

    console.log(ideaListCount);
    formData.append(
      "idea_category",
      selectedIdeaCategory === "Other"
        ? selectedOtherIdeaCategory
        : selectedIdeaCategory
    );
    formData.append("part_description", partDesc);
    formData.append("proposed_idea", proposedIdea);
    formData.append("current_condition", currentCondition);
    formData.append("benefit", tentative);
    formData.append("model", selectedModel);
    formData.append("varient", selectedVariant);
    formData.append("subvarient", selectedSubVariant);
    formData.append("status", "inprogress");
    formData.append(
      "domain",
      selectedDomain === "Other" ? selectedOtherDomain : selectedDomain
    );
    formData.append("function", functionName);
    formData.append("location", selectedLocation);
    formData.append("il1_pd_assigned_id", selectedPDOwnerId);
    formData.append("il1_pd_assigned", selectedPDOwnerName);
    formData.append("il1_sourcing_assigned_id", selectedSourcingOwnerId);
    formData.append("il1_sourcing_assigned", selectedSourcingOwnerName);
    formData.append("idea_effective", selectedIdeaEffectiveAggregate);

    try {
      const response = await axios.post(VAVE + SAVEIDEAGENERATION, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Idea submitted successfully!");

      setPartNo("");
      setPartDesc("");
      setProposedIdea("");
      setCurrentCondition("");
      setTentative("");
      setselectedModel("");
      setSelectedVariant("");
      setSelectedSubVariant("");
      setselectedDomain("");
      setFunctionName("");
      setselectedLocation("");
      setselectedIdeaCategory("");
      setselectedOtherIdeaCategory("");
      setselectedIdeaEffectiveAggregate("");
      setselectedPDOwnerId("");
      setselectedPDOwnerName("");
      setselectedSourcingOwnerId("");
      setselectedSourcingOwnerName("");
      setSelectedFile(null);
      Setisloading(false);
    } catch (error) {
      Setisloading(false);
      console.error("Upload failed:", error);
      alert("Upload failed. Please try again.");
    }
  };

  // const handleSubmit = (e) => {
  //   console.log("", partNo);
  //   e.preventDefault();

  //   // Collect and validate required fields
  //   if (
  //     !selectedIdeaCategory ||
  //     (selectedIdeaCategory === "Other" &&
  //       !document.getElementById("otherIdeaCategory")?.value) ||
  //     !document.getElementById("partNo").value ||
  //     !document.getElementById("partDesc").value ||
  //     !document.getElementById("proposedIdea").value ||
  //     !document.getElementById("currentCondition").value ||
  //     !document.getElementById("savings").value ||
  //     !selectedIdeaEffectiveAggregate ||
  //     !selectedModel ||
  //     !selectedVariant ||
  //     !selectedDomain ||
  //     (selectedDomain === "Other" &&
  //       !document.getElementById("otherDomain")?.value) ||
  //     !document.getElementById("function").value ||
  //     !selectedLocation
  //   ) {
  //     alert("Please fill all the required fields.");
  //     return;
  //   }

  //   // Optional: Validate file input if needed
  //   const file = document.getElementById("supportingFile").files[0];
  //   if (file && file.type !== "application/pdf") {
  //     alert("Only PDF files are allowed.");
  //     return;
  //   }

  //   if (file && file.size > 5000000) {
  //     alert("Upload Size should not exceed 5 MB");
  //     return;
  //   }

  //   // If all fields are valid
  //   alert("Form submitted successfully (mock)!");

  // };

  /// api

  useEffect(() => {
    fetchAllData();
  }, []);
  const fetchAllData = () => {
    axios({
      method: "get",
      url: VAVE + GETIDEACATEGORY,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        console.log("API response:", res.data);
        setIdeaCategoriesList(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });

    axios({
      method: "get",
      url: VAVE + GETDOMAIN,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        console.log("API response:", res.data);
        setDomainList(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching Domain:", error);
      });

    axios({
      method: "get",
      url: VAVE + GETLOCATION,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        console.log("API response:", res.data);
        setLocationList(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching Location:", error);
      });

    axios({
      method: "get",
      url: VAVE + GETIDEAEFFECTIVEAGGREGATE,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        console.log("API response:", res.data);

        setIdeaEffectiveAggregateList(res.data.data);
      })
      .catch((error) => {
        console.error("Error fetching effective aggregate:", error);
      });
    axios({
      method: "get",
      url: VAVE + GETMODEL,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        const data = res.data.data;
        setModelTempList(data);

        const uniqueModels = data.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.model === obj.model)
        );
        setModelList(uniqueModels);
      })
      .catch((error) => {
        console.error("Error fetching model data:", error);
      });




  };

  useEffect(() => {
    if (selectedModel) {
      const variants = modelTempList
        .filter((item) => item.model === selectedModel)
        .map((item) => item.variant)
        .filter((value, index, self) => self.indexOf(value) === index);

      setVariantList(variants);
      setSelectedVariant("");
      setSubVariantList([]);
      setSelectedSubVariant("");
    }
  }, [selectedModel]);

  useEffect(() => {
    if (selectedVariant) {
      const subVariants = modelTempList
        .filter(
          (item) =>
            item.model === selectedModel && item.variant === selectedVariant
        )
        .map((item) => item.sub_variant)
        .filter((value, index, self) => self.indexOf(value) === index);

      setSubVariantList(subVariants);
      setSelectedSubVariant(""); // Reset sub-variant
    }
  }, [selectedVariant]);
  // axios({
  //   method: "get",
  //   url: APP_DEV_URL + VAVE + GETMODEL,
  //   withCredentials: false,
  //   headers: {
  //     "Content-Type": "application/x-www-form-urlencoded",
  //   },
  // })
  //   .then((res) => {
  //     setModelTempList(res.data.data);
  //     const dist = res.data.data.filter(
  //       (obj, index, self) =>
  //         index === self.findIndex((t) => t.model === obj.model)
  //     );
  //     setModelList(dist);
  //   })

  //   .catch((error) => {
  //     console.error("Error fetching categories:", error);
  //   });

  const empId = localStorage.getItem("empid");

const ideaExcelDownloadSubmit = async (event) => {
    Setisloading(true); 
  
     axios({
  method: "get",
  url: `${VAVE}${DOWNLOADIDEABYID}`,
  // url: `${VAVE}${DOWNLOADIDEABYID}`,
  responseType: "blob",               
  withCredentials: false,             
})
  .then((res) => {
    const disposition = res.headers["content-disposition"] || res.headers["Content-Disposition"];
    let filename = "SWON IDEAS.xlsx";
    if (disposition) {
      const match = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"/i.exec(disposition);
      filename = decodeURIComponent(match?.[1] || match?.[2] || filename);
    }

    // Create a blob URL and trigger download
    const blobUrl = window.URL.createObjectURL(new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }));
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
  })
  .catch((error) => {
    console.error("Error downloading excel:", error);
    // Helpful debug:
    if (error.response && error.response.data) {
      // If server accidentally sent JSON error with blob responseType,
      // read it to see the message
      const reader = new FileReader();
      reader.onload = () => console.error("Server error text:", reader.result);
      reader.readAsText(error.response.data);
    }
  });
  Setisloading(false); 
  }


  return (
    <div className="container py-2">

          {adminEmpIds.includes(empId) && (
        <div className="col-md-12">
  <button
    type="button"
    className="btn btn-primary"
    onClick={ideaExcelDownloadSubmit}
  >
    Download Idea Excel
  </button>
</div>

        )}
    <form onSubmit={handleSubmit} className="bg-idea">
      
      <div className="row">
  
        <div className="col-md-4">
          <div className="col">
            <label htmlFor="ideaCategory">Idea Category*</label>
            <select
              id="ideaCategory"
              value={selectedIdeaCategory}
              onChange={(e) => setselectedIdeaCategory(e.target.value)}
              className="form-control"
            >
              <option value="">-- Select --</option>

              {ideaCategoriesList.map((categoryObj) => (
                <option key={categoryObj.id} value={categoryObj.category}>
                  {categoryObj.category}
                </option>
              ))}
            </select>
          </div>
          {selectedIdeaCategory === "Other" && (
            <div className="col-md-12">
              <label htmlFor="otherIdeaCategory">Please specify*</label>
              <input
                type="text"
                id="otherIdeaCategory"
                className="form-control"
                placeholder="Enter Other Idea Category"
                value={selectedOtherIdeaCategory}
                onChange={(e) => {
                  setselectedOtherIdeaCategory(e.target.value);
                }}
                required
              />
            </div>
          )}
        </div>
        <div className="col-md-4">
          <label htmlFor="partNo">Part No*</label>
          <input
            type="text"
            id="partNo"
            className="form-control"
            placeholder="Enter Part No"
            value={partNo}
            onChange={(e) => setPartNo(e.target.value)}
            required
          />
        </div>

        <div className="col-md-4">
          <label htmlFor="partDesc">Part Description*</label>
          <input
            type="text"
            id="partDesc"
            className="form-control"
            placeholder="Enter Part Description"
            value={partDesc}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[a-zA-Z\s]*$/.test(value)) {
                setPartDesc(value);
              }
            }}
            required
          />
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-4">
          <label htmlFor="proposedIdea">Proposed Idea*</label>
          <input
            type="text"
            id="proposedIdea"
            className="form-control"
            placeholder="Enter Proposed Idea"
            value={proposedIdea}
            onChange={(e) => {
              setProposedIdea(e.target.value);
            }}
            required
          />
        </div>
        <div className="col-md-4">
          <label htmlFor="currentCondition">Current Condition*</label>
          <input
            type="text"
            id="currentCondition"
            className="form-control"
            placeholder="Enter Current Condition"
            value={currentCondition}
            onChange={(e) => {
              setCurrentCondition(e.target.value);
            }}
            required
          />
        </div>
        <div className="col-md-4">
          <label htmlFor="savings">Benefits / Tentative Savings*</label>
          <input
            type="text"
            id="savings"
            className="form-control"
            placeholder="Enter Savings"
            value={tentative}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value)) {
                setTentative(value);
              }
            }}
            inputMode="numeric"
            required
          />
          {tentative && (
            <small
              style={{ color: "gray", marginTop: "5px", display: "block" }}
            >
              {numberToWords(tentative)}
            </small>
          )}
        </div>
      </div>

      <div className="row mb-4">
        <div className="row">
          {/* Model Dropdown */}
          <div className="col-md-4">
            <label htmlFor="model">Model*</label>
            <select
              id="model"
              value={selectedModel}
              onChange={(e) => setselectedModel(e.target.value)}
              className="form-control"
            >
              <option value="">-- Select Model --</option>
              {modelList.map((item, index) => (
                <option key={index} value={item.model}>
                  {item.model}
                </option>
              ))}
            </select>
          </div>

          {/* Variant Dropdown */}
          {/* {selectedModel && ( */}
          <div className="col-md-4">
            <label htmlFor="variant">{selectedModel} Variant*</label>
            <select
              id="variant"
              value={selectedVariant}
              onChange={(e) => setSelectedVariant(e.target.value)}
              className="form-control"
            >
              <option value="">-- Select Variant --</option>
              {variantList.map((variant, index) => (
                <option key={index} value={variant}>
                  {variant}
                </option>
              ))}
            </select>
          </div>
          {/* )} */}

          {/* Sub-Variant Dropdown */}
          {/* {selectedVariant && ( */}
          <div className="col-md-4">
            <label htmlFor="subvariant">{selectedVariant} Sub-Variant*</label>
            <select
              id="subvariant"
              value={selectedSubVariant}
              onChange={(e) => setSelectedSubVariant(e.target.value)}
              className="form-control"
            >
              <option value="">-- Select Sub-Variant --</option>
              {subVariantList.map((sub, index) => (
                <option key={index} value={sub}>
                  {sub}
                </option>
              ))}
            </select>
          </div>
          {/* )} */}
        </div>
        {/* <div className="col-md-4">
          <label htmlFor="model">Model*</label>
          <select
            id="model"
            value={selectedModel}
            onChange={(e) => setselectedModel(e.target.value)}
            className="form-control"
          >
            <option value="">-- Select --</option>
            {modelList.map((e, index) => (
              <option value={e.model}>{e.model}</option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label htmlFor="variant">{selectedModel} Main Variant*</label>
          <select
            id="variant"
            value={selectedVariant}
            onChange={(e) => setSelectedVariant(e.target.value)}
            className="form-control"
          >
            <option value="">-- Select --</option>
            {selectedModel === "eLCV" && (
              <option value="eLCV Variant 1">eLCV Variant 1</option>
            )}
            {selectedModel === "eBUS" && (
              <option value="eBUS Variant 1">eBUS Variant 1</option>
            )}
          </select>
        </div> */}
      </div>

      <div className="row mb-4">
        <div className="col-md-4">
          <div className="col">
            <label htmlFor="domain">Domain*</label>
            <select
              id="domain"
              value={selectedDomain}
              onChange={(e) => setselectedDomain(e.target.value)}
              className="form-control"
            >
              <option value="">-- Select --</option>
              {domainList.map((domain) => (
                <option key={domain.id} value={domain.domain}>
                  {domain.domain}
                </option>
              ))}
            </select>
          </div>
          {selectedDomain === "Other" && (
            <div className="col-md-12">
              <label htmlFor="otherDomain">Please specify*</label>
              <input
                type="text"
                id="otherDomain"
                className="form-control"
                placeholder="Enter Other Domain"
                value={selectedOtherDomain}
                onChange={(e) => {
                  setselectedOtherDomain(e.target.value);
                }}
                required
              />
            </div>
          )}
        </div>
        <div className="col-md-4">
          <label htmlFor="function">Function*</label>
          <input
            type="text"
            id="function"
            className="form-control"
            placeholder="Enter Function"
            value={functionName}
            onChange={(e) => {
              setFunctionName(e.target.value);
            }}
            required
          />
        </div>

        <div className="col-md-4">
          <label htmlFor="location">Location*</label>
          <select
            id="location"
            value={selectedLocation}
            onChange={(e) => setselectedLocation(e.target.value)}
            className="form-control"
          >
            <option value="">-- Select --</option>
            {locationList.map((location) => (
              <option key={location.id} value={location.location}>
                {location.location}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-4">
          <label htmlFor="effectiveAggregate">Idea Effective Aggregate*</label>
         <select
  id="effectiveAggregate"
  value={selectedIdeaEffectiveAggregate}
  className="form-control"
  onChange={(e) => {
    const opt = e.target.selectedOptions[0];
    const agg = opt.value;
    

    const selectedItem = ideaEffectiveAggregateList.find(
      item => item.ideaggregate === agg
    );
    
    setselectedIdeaEffectiveAggregate(agg);
    console.log("agg", agg);
    
    if (selectedItem) {
      setselectedPDOwnerName(selectedItem.pd_name || "");
      console.log("setselectedPDOwnerName", selectedItem.pd_name || "");
      setselectedPDOwnerId(selectedItem.pd_empid || "");
      setselectedSourcingOwnerName(selectedItem.sourcing_name || "");
      console.log("setselectedSourcingOwnerName", selectedItem.sourcing_name || "");
      setselectedSourcingOwnerId(selectedItem.sourcing_empid || "");
    } else {
      // Reset values if no item selected (like the "-- Select --" option)
      setselectedPDOwnerName("");
      setselectedPDOwnerId("");
      setselectedSourcingOwnerName("");
      setselectedSourcingOwnerId("");
    }
  }}
>
  <option value="">-- Select --</option>
  {ideaEffectiveAggregateList.map((effectiveAggregate) => (
    <option
      key={effectiveAggregate.id}
      value={effectiveAggregate.ideaggregate}
    >
      {effectiveAggregate.ideaggregate}
    </option>
  ))}
</select>
        </div>
        <div className="col-md-4">
          <label htmlFor="supportingFile">Any documents (PDF, max 5MB)</label>
          <input
            type="file"
            id="supportingFile"
            // accept="application/pdf"
            // onChange={(e) =>
            //   filechangedeed(e.target.files[0] || null, "supportingFile")
            // }
            // value={selectedFile}
            accept=".pdf"
            onChange={filechangedeed}
            name="supportingFile"
          />
        </div>
      </div>

      <button type="submit" className="btn btn-primary">
        Submit Request
      </button>
    </form>
    </div>
  );
}

export default AddRequestForm;
